import React from 'react';

const ACTIONS = { buy: '买入', add: '加仓', hold: '持有', reduce: '减仓' };
const EFFECTS = { support: '支撑', neutral: '中性', caution: '谨慎', oppose: '不利' };

function fmtPct(value) {
  const number = Number(value);
  return Number.isFinite(number) ? `${number.toFixed(2)}%` : '—';
}

export default function MarketPressureTransmissionPanel({ transmission }) {
  if (!transmission?.factors?.length) return <p className="decision-muted">市场压力传导数据不足。</p>;
  const exp = transmission.exposures || {};
  return (
    <div className="market-transmission-panel">
      <div className="market-transmission-hero">
        <div><span>综合传导结论</span><strong>{transmission.overall?.label}</strong><p>{transmission.overall?.conclusion}</p></div>
        <em>数据日 {transmission.as_of || '—'} · 不进入评分</em>
      </div>

      <div className="market-transmission-exposures">
        <div><span>债券基准</span><strong>{fmtPct(exp.bond_benchmark_pct)}</strong><small>报告直接债券 {fmtPct(exp.bonds_pct)}</small></div>
        <div><span>权益基准</span><strong>{fmtPct(exp.equity_benchmark_pct)}</strong><small>报告直接权益 {fmtPct(exp.equity_pct)}</small></div>
        <div><span>现金缓冲</span><strong>{fmtPct(exp.cash_pct)}</strong><small>基准现金 {fmtPct(exp.cash_benchmark_pct)}</small></div>
        <div><span>杠杆率</span><strong>{fmtPct(exp.leverage_pct)}</strong><small>公募基金未穿透 {fmtPct(exp.public_funds_pct)}</small></div>
      </div>

      <div className="market-transmission-factor-grid">
        {transmission.factors.map((factor) => (
          <article className={`market-transmission-factor effect-${factor.effect || 'neutral'}`} key={factor.key}>
            <header><div><span>{factor.label}</span><small>{factor.exposure}</small></div><em>{factor.effect_label || EFFECTS[factor.effect]}</em></header>
            <div className="market-transmission-state"><span>市场状态</span><p>{factor.market_state}</p></div>
            <div className="market-transmission-path"><span>如何传导</span><p>{factor.transmission}</p></div>
            <div className="market-transmission-mini-actions">
              {Object.entries(ACTIONS).map(([key, label]) => {
                const item = factor.actions?.[key];
                return item ? <div key={key}><span>{label}</span><em className={`effect-${item.effect}`}>{EFFECTS[item.effect] || '中性'}</em><p>{item.text}</p></div> : null;
              })}
            </div>
          </article>
        ))}
      </div>

      <div className="market-transmission-actions">
        {Object.entries(ACTIONS).map(([key, label]) => {
          const item = transmission.actions?.[key] || {};
          return <div className={`tone-${item.tone || 'neutral'}`} key={key}><span>{label}</span><strong>{item.label || '观察'}</strong><p>{item.text}</p></div>;
        })}
      </div>
      <p className="market-transmission-limit">{transmission.limitation}</p>
    </div>
  );
}
